// 法务处理
import {
  getLegalAffairs,
  getLawsuit,
  getLegalRecord,
  getToCriminal,
  getActiveAssistance,
  getEntrustOther,
  getCancelLegalAffairs,
  submitLawsuitCase,
  submitConciliation,
  submitOneOpenCourt,
  submitSentence,
  submitAppeal,
  submitExecuteEntry,
  submitLoanLegalAffairsRepayment,
  submitNolleProsequi,
  submitLegalAffairsDetails,
  submitTwoConciliation,
  submitTwoOpenCourt,
  submitTwoSentence,
  submitFollowImplementation,
  submitFulfillImplementation,
  submitLegalSettle,
  submitOtherTrailer,
  submitOptionaLegalAffairsCar,
  submitCriminalRegister,
  submitCriminalSettle
} from '@/api/loanpost/loanLawCl';
import { transferComplaint } from '@/api/loanpost/loanPost'
import { h } from 'vue'
export const option = {
  height: 'auto',
  calcHeight: 30,
  tip: false,
  searchShow: true,
  searchSpan: 5,
  searchMenuSpan: 4,
  border: true,
  index: true,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  selection: false,
  dialogClickModal: false,
  searchLabelWidth: 100,
  column: [
    {
      label: '主键id',
      prop: 'id',
      type: 'input',
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      hide: true,
    },
    {
      label: '进件编号',
      prop: 'businessCode',
      type: 'input',
      minWidth: 120,
      search: true,
      searchOrder: 999,
    },
    {
      label: '所属代理商',
      prop: 'deptName',
      minWidth: 100,
      type: 'input',
    },
    {
      label: '租赁人',
      prop: 'name',
      type: 'input',
      search: true,
      minWidth: 120,
      searchOrder: 998,
      slot:true,
    },
    {
      label: '所属代理商',
      prop: 'deptIds',
      type: 'select',
      filterable: true,
      addDisplay: false,
      editDisplay: false,
      viewDisplay: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: [],
      props: {
        label: 'title',
        value: 'id',
      },
    },
    {
      label: '租赁金额',
      prop: 'lendingAmount',
      type: 'input',
    },
  ],
};
const beFormColumn = [
  {
    label: '剩余金额',
    prop: 'remainingAmount',
    type: 'input',
  },
  {
    label: '车型',
    minWidth: 140,
    prop: 'carModelName',
    type: 'input',
  },
];
const laterColumn = [
  {
    label: '创建日期',
    prop: 'createTime',
    type: 'input',
  },
  {
    label: '滞留时间',
    prop: 'residenceTime',
    type: 'input',
  },
];
// 处理中
export const loanLawCl2 = [...beFormColumn, ...laterColumn];
// 诉讼中 一审 & 诉讼中 二审 & 执行阶段  & 不良资产 & 刑事案件
export const loanLawCl3 = [
  ...beFormColumn,
  {
    label: '状态',
    prop: 'statusName',
    type: 'input',
  },
  ...laterColumn,
];
// 结案
export const loanLawCl4 = [
  {
    label: '剩余金额',
    prop: 'remainingAmount',
    type: 'input',
  },
  {
    label: '结案金额',
    prop: 'criminalSettleAmount',
    type: 'input',
  },
  {
    label: '车型',
    minWidth: 140,
    prop: 'carModelName',
    type: 'input',
  },
  {
    label: '状态',
    prop: 'statusName',
    type: 'input',
  },
  {
    label: '结案日期',
    prop: 'criminalSettleDate',
    type: 'input',
  },
];
// 全部
export const loanLawCl1 = [
  {
    label: '车型',
    minWidth: 140,
    prop: 'carModelName',
    type: 'input',
  },
  {
    label: '进度',
    prop: 'currentModuleName',
    type: 'input',
  },
  {
    label: '状态',
    prop: 'statusName',
    type: 'input',
  },
  ...laterColumn,
];

export const typeList = [
  {
    label: '全部',
    value: 1,
  },
  {
    label: '待处理',
    value: 2,
  },
  {
    label: '诉讼中（一审）',
    value: 3,
  },
  {
    label: '诉讼中（二审）',
    value: 4,
  },
  {
    label: '执行阶段',
    value: 5,
  },
  {
    label: '不良资产',
    value: 7,
  },
  {
    label: '刑事案件',
    value: 6,
  },
  {
    label: '结案',
    value: 8,
  },
];

// buttonName 按钮名称
// iconfont 图标class
// dialogShow 对话框显示
// buttonShow 按钮是否现实
// requestFun 请求方法名
// buttonType 按钮类型 38及以前已占用
// isAgentShow 代理商 是否显示
export const operationButtonList = {
  // 待处理
  2: [
    {
      buttonName: '诉讼',
      iconfont: 'iconfont icon-falvsusong font-size_12',
      dialogShow: 'lawsuitVisible',
      buttonShow: null,
      requestFun: getLawsuit,
      buttonType: 1,
      isAgentShow:true,
    },
    {
      buttonName: '法务记录',
      iconfont: 'iiconfont icon-zhongbiaojieguotongzhi font-size_14',
      dialogShow: 'lawsuitVisible',
      buttonShow: null,
      requestFun: getLegalRecord,
      buttonType: 2,
    },
    {
      buttonName: '客户还租',
      iconfont: 'iconfont icon-zhekou font-size_14',
      dialogShow: 'collectRepaymentVisible',
      buttonShow: null,
      requestFun: getLegalAffairs,
      buttonType: 3,
    },
    {
      buttonName: '转刑事',
      iconfont: 'iconfont icon-xingshifuhe font-size_12',
      dialogShow: 'lawsuitVisible',
      buttonShow: null,
      requestFun: getToCriminal,
      buttonType: 4,
      isAgentShow:true,
    },
    {
      buttonName: '行动协助',
      iconfont: 'iconfont icon-xiezhu font-size_14',
      dialogShow: 'lawsuitVisible',
      buttonShow: null,
      requestFun: getActiveAssistance,
      buttonType: 5,
    },
    {
      buttonName: '委托第三方',
      iconfont: 'iconfont icon-shouquanweituoshu font-size_12',
      dialogShow: 'lawsuitVisible',
      buttonShow: null,
      requestFun: getEntrustOther,
      buttonType: 6,
    },
    {
      buttonName: '作废',
      iconfont: 'iconfont icon-zuofei font-size_12',
      dialogShow: 'lawsuitVisible',
      buttonShow: null,
      requestFun: getCancelLegalAffairs,
      buttonType: 7,
    },
    {
      buttonName: '转投诉',
      iconfont: 'iconfont icon-xiezhu font-size_14',
      dialogShow: 'lawsuitVisible',
      buttonShow: null,
      requestFun: transferComplaint,
      buttonType: 38,
    },
  ],
  // 诉讼中（一审）
  3: [
    {
      buttonName: '诉讼立案',
      iconfont: 'iconfont icon-fabuzhongbiaogonggao font-size_14',
      dialogShow: 'inLitigationVisible',
      buttonShow: [2],
      requestFun:submitLawsuitCase,
      buttonType:8,
      isAgentShow:true,
    },
    {
      buttonName: '调解',
      iconfont: 'iconfont icon-wodetiaojie font-size_14',
      dialogShow: 'inLitigationVisible',
      buttonShow: [3],
      requestFun:submitConciliation,
      buttonType:9,
      isAgentShow:true,
    },
    {
      buttonName: '开庭',
      iconfont: 'iconfont icon-panjuejieguo1 font-size_14',
      dialogShow: 'inLitigationVisible',
      buttonShow: [3],
      requestFun:submitOneOpenCourt,
      buttonType:10,
      isAgentShow:true,
    },
    {
      buttonName: '判决',
      iconfont: 'iconfont icon-panjuejieguo1 font-size_14',
      dialogShow: 'inLitigationVisible',
      buttonShow: [5],
      requestFun:submitSentence,
      buttonType:11,
      isAgentShow:true,
    },
    {
      buttonName: '上诉',
      iconfont: 'iconfont icon-shipintongdao-shangsu font-size_14',
      dialogShow: 'inLitigationVisible',
      buttonShow: [6],
      requestFun:submitAppeal,
      buttonType:12,
      isAgentShow:true,
    },
    {
      buttonName: '执行',
      iconfont: 'iconfont icon-wanchengzhihang font-size_14',
      dialogShow: 'inLitigationVisible',
      buttonShow: [6],
      requestFun:submitExecuteEntry,
      buttonType:13,
      isAgentShow:true,
    },
    {
      buttonName: '调解收款',
      iconfont: 'iconfont icon-qianfei font-size_14',
      dialogShow: 'gatheringVisible',
      buttonShow: [4],
      requestFun:submitLoanLegalAffairsRepayment,
      buttonType:14,
      isAgentShow:true,
    },
    {
      buttonName: '撤诉',
      iconfont: 'iconfont icon-chexiao font-size_14',
      dialogShow: 'inLitigationVisible',
      buttonShow: [2, 3, 5, 6],
      requestFun:submitNolleProsequi,
      buttonType:15,
      isAgentShow:true,
    },
    {
      buttonName: '诉讼详情',
      iconfont: 'iconfont icon-shensu font-size_14"',
      dialogShow: 'lawsuitDetailsVisible',
      buttonShow: [2, 3, 4, 5, 6],
      requestFun:submitLegalAffairsDetails,
      buttonType:16,
      isAgentShow:true,
    },
  ],
  // 诉讼中 二审
  4: [
    {
      buttonName: '调解',
      iconfont: 'iconfont icon-wodetiaojie font-size_14',
      dialogShow: 'inLitigationVisible',
      buttonShow: [7],
      requestFun:submitTwoConciliation,
      buttonType:17,
      isAgentShow:true,
    },
    {
      buttonName: '开庭',
      iconfont: 'iconfont icon-panjuejieguo1 font-size_14',
      dialogShow: 'inLitigationVisible',
      buttonShow: [7],
      requestFun:submitTwoOpenCourt,
      buttonType:18,
      isAgentShow:true,
    },
    {
      buttonName: '判决',
      iconfont: 'iconfont icon-panjuejieguo1 font-size_14',
      dialogShow: 'inLitigationVisible',
      buttonShow: [9],
      requestFun:submitTwoSentence,
      buttonType:19,
      isAgentShow:true,
    },
    {
      buttonName: '执行',
      iconfont: 'iconfont icon-wanchengzhihang font-size_14',
      dialogShow: 'inLitigationVisible',
      buttonShow: [10],
      requestFun:submitExecuteEntry,
      buttonType:20,
      isAgentShow:true,
    },
    {
      buttonName: '调解收款',
      iconfont: 'iconfont icon-qianfei font-size_14',
      dialogShow: 'gatheringVisible',
      buttonShow: [8],
      requestFun:submitLoanLegalAffairsRepayment,
      buttonType:21,
      isAgentShow:true,
    },
    {
      buttonName: '诉讼详情',
      iconfont: 'iconfont icon-shensu font-size_14',
      dialogShow: 'lawsuitDetailsVisible',
      buttonShow: [7, 8, 9,10],
      requestFun:submitLegalAffairsDetails,
      buttonType:22,
      isAgentShow:true,
    },
  ],
  // 执行阶段
  5: [
    {
      buttonName: '跟进执行',
      iconfont: 'iconfont icon-genjin22 font-size_14',
      dialogShow: 'followImplementationVisible',
      buttonShow: [14],
      requestFun: submitFollowImplementation,
      buttonType:23,
      isAgentShow:true,
    },
    {
      buttonName: '完成执行',
      iconfont: 'iconfont icon-wanchengzhihang font-size_14',
      dialogShow: 'gatheringVisible',
      buttonShow: [12],
      requestFun: submitFulfillImplementation,
      buttonType:24,
      isAgentShow:true,
    },
    {
      buttonName: '执行收款',
      iconfont: 'iconfont icon-a-zichan2 font-size_14',
      dialogShow: 'gatheringVisible',
      buttonShow: [13],
      requestFun: submitLoanLegalAffairsRepayment,
      buttonType:25,
      isAgentShow:true,
    },
    {
      buttonName: '诉讼详情',
      iconfont: 'iconfont icon-shensu font-size_14"',
      dialogShow: 'lawsuitDetailsVisible',
      buttonShow: [14, 12, 13],
      requestFun: submitLegalAffairsDetails,
      buttonType:26,
      isAgentShow:true,
    },
  ],
  // 不良资产
  7: [
    {
      buttonName: '三方拖车',
      iconfont: 'iconfont icon-a-18tuocheguanliymian font-size_12',
      dialogShow: 'otherTrailerVisible',
      buttonShow: [17],
      requestFun: submitOtherTrailer,
      buttonType:27
    },
    {
      buttonName: '法务结清',
      iconfont: 'iconfont icon-ic_jieqingguanli font-size_14',
      dialogShow: 'otherTrailerVisible',
      requestFun: submitLegalSettle,
      buttonShow: [19],
      buttonType:28
    },
    {
      buttonName: '转卖车',
      iconfont: 'iconfont icon-ic_jieqingguanli font-size_14',
      dialogShow: 'otherTrailerVisible',
      requestFun: submitOptionaLegalAffairsCar,
      buttonShow: [19],
      buttonType:36
    },
    {
      buttonName: '卖车',
      iconfont: 'iconfont icon-maiche font-size_12',
      dialogShow: 'saleCarFlag',
      buttonShow: [21],
      buttonType:29
    },
  ],
  // 刑事案件
  6: [
    {
      buttonName: '刑事立案',
      iconfont: 'iconfont icon-panjuejieguo1 font-size_14',
      dialogShow: 'criminalVisible',
      buttonShow: [11],
      requestFun: submitCriminalRegister,
      buttonType:31,
      isAgentShow:true,
    },
    {
      buttonName: '刑事结案',
      iconfont: 'iconfont icon-zhongjiejiean font-size_14',
      dialogShow: 'criminalVisible',
      requestFun: submitCriminalSettle,
      buttonShow: [15],
      buttonType:32,
      isAgentShow:true,
    },
    {
      buttonName: '刑案收款',
      iconfont: 'iconfont icon-qianfei font-size_14',
      dialogShow: 'criminalCollectionVisible',
      requestFun: submitLoanLegalAffairsRepayment,
      buttonShow: [16],
      buttonType:33,
      isAgentShow:true,
    },
    {
      buttonName: '刑案详情',
      iconfont: 'iconfont icon-shensu font-size_14"',
      dialogShow: 'criminalDetailsVisible',
      buttonShow: null,
      requestFun: submitLegalAffairsDetails,
      buttonType:34,
      isAgentShow:true,
    },
  ],
  // 结案
  8: [
    {
      buttonName: '诉讼详情',
      iconfont: 'iconfont icon-shensu font-size_14"',
      dialogShow: 'lawsuitDetailsVisible',
      buttonShow: [4,8,13],
      requestFun:submitLegalAffairsDetails,
      buttonType:35,
      isAgentShow:true,
    },
    {
      buttonName: '刑案详情',
      iconfont: 'iconfont icon-shensu font-size_14"',
      dialogShow: 'criminalDetailsVisible',
      requestFun:submitLegalAffairsDetails,
      buttonShow: [16],
      buttonType:37,
      isAgentShow:true,
    },
  ],
};
// 状态的枚举
// TYPE_1(1,"沟通中"),
// 	TYPE_2(2,"一审-已递交资料"),
// 	TYPE_3(3,"一审-已诉讼立案"),
// 	TYPE_4(4,"一审-庭前调解"),
// 	TYPE_5(5,"一审-已开庭"),
// 	TYPE_6(6 ,"一审-已判决"),
// 	TYPE_7(7,"二审-待开庭"),
// 	TYPE_8(8,"二审-庭前调解"),
// 	TYPE_9(9,"二审-已开庭"),
// 	TYPE_10(10,"二审-已判决"),
// 	TYPE_11(11,"待立案"), 待刑事立案
// 	TYPE_12(12,"执行中"),
// 	TYPE_13(13,"已执行"),
// 	TYPE_14(14,"待执行立案"),
// 	TYPE_15(15,"已刑事立案"),
// 	TYPE_16(16,"刑事结案"),
// 	TYPE_17(17,"委托第三方"),
// 	TYPE_18(18,"行动协助"),
// 	TYPE_19(19,"法务谈判"),
// 	TYPE_20(20,"法务待售"),
// 	TYPE_21(21,"法务卖车"),
// 	TYPE_22(22,"已客户还租"),
// 	TYPE_999(999,"作废"),
